module.exports = __webpack_public_path__ + "img/konut-sigortasi.6190b6f8.png";